<div class="container">
  <div class="container__middle empty-setup" *ngIf="!automation.name || !automation.target_model; else setupComplete">
    <button (click)="open.emit()" mat-flat-button><mat-icon>settings</mat-icon>&nbsp;Setup the Object Type</button>
  </div>
  <ng-template #setupComplete>
    <div class="container__top">
      <span><mat-icon svgIcon="heroicons_outline:information-circle"></mat-icon>&nbsp;Basic Info</span>
      <mat-icon #origin (click)="overlayHelper.open()" class="container__top__setup-button"
        >keyboard_arrow_down</mat-icon
      >
      <app-overlay-helper class="display-none" #overlayHelper [overlayOrigin]="origin" [position]="position">
        <div class="options-panel">
          <p>Options</p>
          <p (click)="openSetup()"><mat-icon>edit</mat-icon>&nbsp;Edit</p>
        </div>
      </app-overlay-helper>
    </div>
    <div class="container__middle">
      <p>
        <strong>{{ automation.name }}</strong>
      </p>
      <p>
        Object Type: <strong>{{ automation.target_model | relatedToTypeTitle: objects }}</strong>
      </p>
    </div>
  </ng-template>
</div>
